import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecruitment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 70,
	height: 70,
	viewBox: "0 0 70 70",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1871_8906)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M34.4933 27.536C40.7085 27.536 45.7653 22.4792 45.7653 16.2639C45.7653 14.3758 45.2929 12.598 44.4692 11.0326L48.7288 7.81252L47.5303 6.22764L43.385 9.36134C41.3206 6.70887 38.1066 4.99146 34.4928 4.99146C28.2775 4.99146 23.2197 10.0482 23.2197 16.2635C23.2202 22.4787 28.2781 27.536 34.4933 27.536ZM34.4933 6.97865C37.4607 6.97865 40.102 8.38389 41.8022 10.5581L32.915 17.2772L29.5081 13.8682L28.1023 15.2734L32.7321 19.9066L42.8544 12.255C43.4392 13.4706 43.778 14.8277 43.778 16.265C43.778 21.3844 39.6131 25.5503 34.4927 25.5503C29.3721 25.5503 25.2062 21.3845 25.2062 16.265C25.2062 11.1452 29.3729 6.97865 34.4933 6.97865Z",
				fill: "#152A58"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.2727 34.4356C17.9148 34.4356 21.6903 30.6595 21.6903 26.0163C21.6903 21.3743 17.9148 17.5981 13.2727 17.5981C8.6306 17.5981 4.85449 21.3743 4.85449 26.0163C4.85393 30.6595 8.6306 34.4356 13.2727 34.4356ZM13.2727 19.586C16.8187 19.586 19.7035 22.4708 19.7035 26.0174C19.7035 29.5641 16.8187 32.45 13.2727 32.45C9.72659 32.45 6.84125 29.5647 6.84125 26.0174C6.84069 22.4708 9.72545 19.586 13.2727 19.586Z",
				fill: "#152A58"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.1357 26.0161C47.1357 30.6582 50.9119 34.4354 55.5539 34.4354C60.1959 34.4354 63.972 30.6593 63.972 26.0161C63.972 21.374 60.1959 17.5979 55.5539 17.5979C50.9123 17.5979 47.1357 21.3753 47.1357 26.0161ZM55.5539 19.5853C59.1 19.5853 61.9852 22.4701 61.9852 26.0167C61.9852 29.5634 59.1 32.4493 55.5539 32.4493C52.0077 32.4493 49.1225 29.5639 49.1225 26.0167C49.1225 22.4701 52.0084 19.5853 55.5539 19.5853Z",
				fill: "#152A58"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.4028 48.7928C69.4028 41.3154 63.3201 35.2319 55.8426 35.2319C53.6562 35.2319 51.5136 35.7574 49.5911 36.7564C46.2319 32.2949 40.8941 29.4036 34.892 29.4036C28.8254 29.4036 23.4365 32.3582 20.085 36.9034C18.0927 35.8079 15.8564 35.2321 13.5603 35.2321C6.08289 35.2321 0 41.3154 0 48.7929V59.1481H16.5001V61.749H53.282V59.1481H69.4031L69.4028 48.7928ZM31.2102 35.4432L30.1509 38.8945L27.0565 33.3855C27.8525 32.9509 28.6963 32.5939 29.5655 32.2946L31.2102 35.4432ZM33.0135 36.3385H36.155L37.7902 41.3236L34.8395 47.2413L31.4952 41.2882L33.0135 36.3385ZM39.0508 38.7948L37.9422 35.4156L39.5564 32.0746C40.3813 32.3202 41.1729 32.6368 41.9378 33.0027L39.0508 38.7948ZM37.5674 31.6283L36.2514 34.3518H32.8823L31.5185 31.7423C32.6079 31.5135 33.736 31.3905 34.8922 31.3905C35.8047 31.3892 36.6937 31.4837 37.5674 31.6283ZM1.98747 57.1611V48.7926C1.98747 42.4105 7.17943 37.2185 13.561 37.2185C15.4685 37.2185 17.3255 37.6863 18.9915 38.5728C17.4115 41.2857 16.5018 44.436 16.5018 47.7952V57.1609L1.98747 57.1611ZM51.296 59.7619H45.0663V50.153H43.0795V59.7619H25.9325V50.153H23.9457V59.7619H18.4876V47.7954C18.4876 42.2976 21.215 37.4341 25.3787 34.4557L34.9443 51.4823L43.6797 33.9648C48.2502 36.8794 51.2963 41.9827 51.2963 47.7944L51.296 59.7619ZM67.417 57.1611H53.2824V47.7954C53.2824 44.3735 52.3401 41.1698 50.7071 38.4227C52.2957 37.6349 54.0513 37.2181 55.8429 37.2181C62.2245 37.2181 67.4165 42.41 67.4165 48.7922L67.417 57.1611Z",
				fill: "#152A58"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.4932 64.3052H52.2884V66.2919H17.4932V64.3052Z",
				fill: "#152A58"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.4932 68.0132H25.7096V69.9999H17.4932V68.0132Z",
				fill: "#152A58"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.1309 68.0132H52.2869V69.9999H28.1309V68.0132Z",
				fill: "#152A58"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.498 0H35.4848V2.91415H33.498V0Z",
				fill: "#152A58"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.5957 15.2705H21.6013V17.2573H18.5957V15.2705Z",
				fill: "#152A58"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.8066 15.2705H50.8112V17.2573H47.8066V15.2705Z",
				fill: "#152A58"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1871_8906",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 70,
			height: 70,
			fill: "white"
		})
	}) })]
});
export default SvgRecruitment;
